<div class="btn-actions" *ngIf="actions">
    <button
        class="btn btn-link"
        *ngFor="let action of params['actions']; let i=index"
        [ngClass]="{'m-r--0': actions.length == (i+1), 'm-r--10': actions.length != (i+1)}" (click)="action.onClick(params)">
        <span>{{action.title}}</span>
    </button>
</div>
